import React from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

const NotFount = () => (
  <section className="min-h-full flex items-center justify-center">
    <div className="container text-center">
      <h1>
        <span className="block text-red-500 text-8xl font-light ">404</span>
        <span className="block text-3xl ">Page not found</span>
      </h1>
      <p className="w-fit mx-auto text-lg text-gray-700  px-3 rounded-lg border-2 border-dashed border-red-500 p-1">
        Please check thr URL in the address bar and try again.
      </p>
      <Button className="mt-10" variant="contained" component={Link} to="/home">
        Go Back Home
      </Button>
    </div>
  </section>
);

export default NotFount;
